import { render, staticRenderFns } from "./add_user.vue?vue&type=template&id=52bc0b22&scoped=true&"
import script from "./add_user.vue?vue&type=script&lang=js&"
export * from "./add_user.vue?vue&type=script&lang=js&"
import style0 from "./add_user.vue?vue&type=style&index=0&id=52bc0b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc0b22",
  null
  
)

export default component.exports